import { noneProfile, profileVerified, TickIcon } from "assets";
import ImageUrl from "components/app/image-url/ImageUrl";
import ImageUrlCoverProfile from "components/app/image-url/ImageUrlCoverProfile";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import QrCodeGenerater from "components/app/qr-code-generater/QrCodeGenerater";
import UploadPersionalProfile from "components/app/upload-profile/UploadPersionalProfile";
import { Carousel, CarouselContent, CarouselItem } from "components/ui/carousel";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription, DialogClose, DialogFooter } from "components/app/dialog/dialog";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "components/ui/alert-dialog";
import Layout from "layout/layout";
import SettingContentLayout from "layout/setting-content/SettingContentLayout";
import { Copy, Heart, House, Info, Loader, MapPin, Pencil, X } from "lucide-react";

import { useEffect, useState } from "react";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { Separator } from "components/ui/separator";
import moment from "moment";
import { Link } from "react-router-dom";
import DailogCurrentAddress from "./dailog-edit-profile-detail/DailogCurrentAddress";
import DailogBirthAddress from "./dailog-edit-profile-detail/DailogBirthAddress";
import DailogMaritalStatus from "./dailog-edit-profile-detail/DailogMaritalStatus";
import DailogFacebook from "./dailog-edit-profile-detail/DailogFacebook";
import DailogTelegram from "./dailog-edit-profile-detail/DailogTelegram";
import DailogYoutube from "./dailog-edit-profile-detail/DailogYoutube";
import DailogTiktok from "./dailog-edit-profile-detail/DailogTiktok";
import { Button } from "components/ui/button";
import UploadCoverPersionalProfile from "components/app/upload-cover-profile/UploadCoverPersionalProfile";
import DailogProfessional from "./dailog-edit-profile-detail/DailogProfessional";
import DailogEducations from "./dailog-edit-profile-detail/DailogEducations";
import DailogWorkplace from "./dailog-edit-profile-detail/DailogWorkplace";
import DailogEditUserProfile from "./dailog-edit-profile-detail/DailogEditUserProfile";
import GoogleMapPreview from "components/app/google-map/GoogleMapPreview";
import DailogEditPageProfile from "./dailog-edit-profile-detail/DailogEditPageProfile";
import DailogCategories from "./dailog-edit-profile-detail/DailogCategories";
import DialogClickCoverProfile from "pages/setting-and-account/profile-detail/dialog-click-cover-profile/DialogClickCoverProfile";
import DialogClickProfilePicture from "pages/setting-and-account/profile-detail/dialog-click-profile-picture/DialogClickProfilePicture";
import useClipboard from "react-use-clipboard";
import DailogGoogleMapLink from "./dailog-edit-profile-detail/DailogGoogleMapLink";
import DialogShowUserPosts from "pages/profile/dialog/DialogShowUserPosts";
import DialogShowUserLikes from "pages/profile/dialog/DialogShowUserLikes";

export default function ProfileDetail() {
  const { token } = useAppSelector((state) => state.auth);
  const [loadingItemWorkplaceId, setLoadingItemWorkplaceId] = useState<string | null>(null);
  const [loadingItemEducationId, setLoadingItemEducationId] = useState<string | null>(null);
  const [editWorkplace, setEditWorkplace] = useState<any>(null);

  const [isDialogOpenWorkplace, setIsDialogOpenWorkplace] = useState<boolean>(false);
  const [editEducation, setEditEducation] = useState<any>(null);
  const [isDialogOpenEducation, setIsDialogOpenEducation] = useState<boolean>(false);
  const [isDialogOpenProfessional, setIsDialogOpenProfessional] = useState<boolean>(false);
  const [isDialogOpenCategory, setIsDialogOpenCategory] = useState<boolean>(false);
  const [isDialogOpenCurrentAddress, setIsDialogOpenCurrentAddress] = useState<boolean>(false);
  const [isDialogOpenMaritalStatus, setIsDialogOpenMaritalStatus] = useState<boolean>(false);
  const [isDialogOpenBirthAddress, setIsDialogOpenBirthAddress] = useState<boolean>(false);
  const [isDialogOpenFaceBook, setIsDialogOpenFaceBook] = useState<boolean>(false);
  const [isDialogOpenTelegram, setIsDialogOpenTelegram] = useState<boolean>(false);
  const [isDialogOpenYoutube, setIsDialogOpenYoutube] = useState<boolean>(false);
  const [isDialogOpenTiktok, setIsDialogOpenTiktok] = useState<boolean>(false);
  const [isDialogOpenCoverProfile, setIsDialogOpenCoverProfile] = useState<boolean>(false);
  const [userAllCoverProfiles, setUserAllCoverProfiles] = useState<any>();
  const [userUpdateProfileInformation, setUserUpdateProfileInformation] = useState<any>();
  const [itemCoverProfile, setItemCoverProfile] = useState<any>();
  const [userProfileDetail, setUserProfileDetail] = useState<any>();
  const [user, setUser] = useState<any>(null);
  const [isDialogOpenProfilePicture, setIsDialogOpenProfilePicture] = useState<boolean>(false);
  const [isDialogOpenGoogleMapLink, setIsDialogOpenGoogleMapLink] = useState<boolean>(false);

  const linkUrlClipboard = `${process.env.REACT_APP_URL}/profile?id=
    ${userProfileDetail?.user?.id}`;
  const [isCopied, setCopied] = useClipboard(linkUrlClipboard, {
    successDuration: 1000,
  });

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const initUpdateProfileInfo = async () => {
    try {
      const url = `${RouteApi.getPageInformation}token=${token}`;
      const data = {
        user_id: userProfileDetail.user.id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setUserUpdateProfileInformation(response.user);
      }
    } catch (error) {
      AppLog.show({
        message: `[initUpdateProfileInfo]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const fetchGetProfileInfo = async (user: any) => {
    try {
      const url = `${RouteApi.getProfileInfo}token=${token}`; // Properly format the URL
      const data = {
        user_id: user.id,
      };

      const response = await RequestApi(url, { data });

      if (response.status === "success") {
        setUserProfileDetail(response);
      }
    } catch (error) {
      AppLog.show({
        message: `[fetchGetProfileInfo]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const submitRemoveUserWorkplace = async (item: any) => {
    setLoadingItemWorkplaceId(item.id);
    try {
      const url = `${RouteApi.submitRemoveUserWorkplace}token=${token}`;
      const data = {
        user_workplace_id: item.id,
        company_name: item.company_name,
        job_title: item.job_title,
        starting_date: item.starting_date,
        ending_date: item.ending_date,
        job_description: item.job_description,
        is_present: item.is_present,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        const updateUser = userProfileDetail?.user_workplaces.filter((element: any) => element.id !== item.id);
        setUserProfileDetail((prev: any) => ({
          ...prev,
          user_workplaces: updateUser,
        }));
      }
    } catch (error: any) {
      AppLog.show({
        message: `[submitRemoveUserWorkplace]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingItemWorkplaceId(null); // Reset loading state
    }
  };

  const submitRemoveUserEducation = async (item: any) => {
    setLoadingItemEducationId(item.id); // Reset loading state
    try {
      const url = `${RouteApi.submitRemoveUserEducation}token=${token}`;
      const data = {
        user_education_id: item.id,
        school_name: item.school_name,
        concentration: item.concentration,
        starting_date: item.starting_date,
        ending_date: item.ending_date,
        is_present: item.is_present,
        is_graduated: item.is_graduated,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        const updateUser = userProfileDetail?.user_educations.filter((element: any) => element.id !== item.id);
        setUserProfileDetail((prev: any) => ({
          ...prev,
          user_educations: updateUser,
        }));
      }
    } catch (error) {
      AppLog.show({
        message: `[submitRemoveUserEducation]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingItemEducationId(null); // Reset loading state
    }
  };

  const submitDeleteProfileCover = async (item: any) => {
    setLoadingItemEducationId(item.id); // Reset loading state
    try {
      const url = `${RouteApi.submitDeleteProfileCover}token=${token}`;
      const data = {
        id: item.id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        const updateUser = {
          ...userProfileDetail,
        };
        updateUser.user_cover_pictures = response.user_cover_pictures;
        setUserProfileDetail(updateUser);
        setUserAllCoverProfiles(response.user_cover_pictures);
      }
    } catch (error) {
      AppLog.show({
        message: `[submitDeleteProfileCover]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingItemEducationId(null); // Reset loading state
    }
  };

  useEffect(() => {
    if (user) {
      fetchGetProfileInfo(user);
    }
  }, [user]);

  useEffect(() => {
    if (userProfileDetail) {
      initUpdateProfileInfo();
    }
  }, [userProfileDetail]);

  return (
    <SettingContentLayout>
      {userProfileDetail ? (
        <>
          {/* CoverUserProfileDetail */}
          <div className="">
            <div className="relative flex justify-center rounded-3xl w-full h-[200px] sm:h-[300px] md:h-[400px]">
              <Carousel className="h-full border-none">
                <CarouselContent className="w-full h-[200px] sm:h-[300px] md:h-[400px] border-none rounded-t-lg aspect-[16/9] bg-white">
                  {userProfileDetail?.user_cover_pictures.length > 0 ? (
                    <>
                      {userProfileDetail?.user_cover_pictures.map((coverPicture: any, coverIndex: number) => {
                        return (
                          <CarouselItem
                            key={coverIndex}
                            className="rounded-3xl cursor-grab"
                            onClick={() => {
                              setIsDialogOpenCoverProfile(true);
                              setItemCoverProfile(coverPicture); // Set the selected cover picture
                              setUserAllCoverProfiles(userProfileDetail?.user_cover_pictures);
                            }}
                          >
                            <ImageUrlCoverProfile
                              src={coverPicture.picture}
                              className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover rounded-t-lg aspect-[9/16]"
                              alt="cover"
                            />
                          </CarouselItem>
                        );
                      })}
                    </>
                  ) : (
                    <CarouselItem className="rounded-3xl">
                      <img src={noneProfile} className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover rounded-b-3xl aspect-[9/16]" alt="cover" />
                    </CarouselItem>
                  )}
                </CarouselContent>
              </Carousel>

              <button className="absolute bottom-4 right-6 border p-2 bg-gray-200 dark:bg-accent dark:hover:bg-slate-900 rounded-full">
                <UploadCoverPersionalProfile
                  user={userProfileDetail?.user_cover_pictures}
                  onUploadSuccess={(valueSuccess: any) => {
                    if (valueSuccess?.user_cover_pictures?.length > 0) {
                      const updatedUserCoverPictures = valueSuccess.user_cover_pictures;

                      setUserProfileDetail((prevState: any) => ({
                        ...prevState,
                        user_cover_pictures: updatedUserCoverPictures,
                      }));
                    }
                  }}
                />
              </button>
            </div>

            {/* UserProfileDetail */}
            <div className="relative flex justify-start">
              <div className="absolute -top-16 left-8 flex flex-col text-center">
                <div className="relative">
                  <div className="cursor-pointer" onClick={() => setIsDialogOpenProfilePicture(true)}>
                    <ImageUrl src={userProfileDetail?.user.picture} className="rounded-full w-[140px] h-[140px] border-4 bg-white" />
                  </div>

                  <button className="absolute bottom-2 right-1 p-1 rounded-full z-20 bg-gray-200 dark:bg-accent dark:hover:bg-slate-900">
                    <UploadPersionalProfile
                      onUploadSuccess={(valueSuccess: any) => {
                        if (valueSuccess?.picture) {
                          const updatedUser = {
                            ...userProfileDetail?.user,
                            picture: valueSuccess.picture,
                            thumbnail: valueSuccess.thumbnail,
                          };

                          localStorage.setItem("user", JSON.stringify(updatedUser));
                          // Update the state properly to trigger re-render
                          setUserProfileDetail((prevState: any) => ({
                            ...prevState,
                            user: updatedUser, // Set the updated user object in the state
                          }));
                        }
                      }}
                    />
                  </button>
                </div>
              </div>
            </div>
            <div className="flex justify-end me-2 mt-2 space-x-2">
              <QrCodeGenerater
                linkUrlClipboard={`https://flipflop.maxx4business.com/@${userProfileDetail?.user?.username}`}
                linkUrl={`${process.env.REACT_APP_URL}/profile?id=${userProfileDetail?.user?.id}`}
                className="p-1 bg-gray-200 dark:bg-accent dark:hover:bg-slate-900 w-9 h-9 rounded-full border cursor-pointer"
                user={userProfileDetail?.user}
              />

              {/* {userProfileDetail?.user?.user_type === "Page" ? (
                  <DailogEditPageProfile
                    userUpdateProfileInformation={userUpdateProfileInformation}
                    onValueChange={(value) => {
                      const updatedUser = {
                        ...userProfileDetail.user,
                        ...value,
                      };
                      setUserProfileDetail({
                        ...userProfileDetail,
                        user: updatedUser,
                      });
                    }}
                  />
                ) : (
                  <DailogEditUserProfile
                    userProfileDetail={userProfileDetail.user}
                    onValueChange={(value) => {
                      const updatedUser = {
                        ...userProfileDetail.user,
                        ...value,
                      };
                      setUserProfileDetail({
                        ...userProfileDetail,
                        user: updatedUser,
                      });
                    }}
                  />
                )} */}
            </div>
          </div>

          <div className="p-4">
            {/* Profile Infomation */}
            <div className="pe-4 space-y-3 mt-10">
              <div>
                {/* Name & Bio */}
                <div className="text-start space-y-2 mb-3">
                  <div className=" flex justify-start">
                    <div className="flex items-center">
                      <p className="text-lg lg:text-xl font-bold line-clamp-1">{userProfileDetail?.user?.name}</p>
                    </div>
                    {userProfileDetail?.is_verified === "Yes" ? (
                      <>
                        <div className="flex items-center justify-center pt-0.5 ml-1">
                          <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>

                  <h1 className="text-md lg:text-md font-semibold line-clamp-2 text-muted-foreground">{userProfileDetail?.user?.bio}</h1>
                </div>
              </div>
            </div>

            {/* Following & Followers & Posts & Likes */}
            <div className="flex justify-start space-x-2 text-center font-bold text-md">
              <div className="flex">
                <p className="mr-1">{userProfileDetail?.user?.no_of_follower}</p>
                <p>Followers</p>
              </div>
              <p> • </p>
              <p className="mr-1">{userProfileDetail?.user?.no_of_following}</p>
              <p>Following</p>
              <p> • </p>
              <DialogShowUserPosts user={userProfileDetail?.user} />
              <p> • </p>
              <DialogShowUserLikes user={userProfileDetail?.user} />
            </div>

            <div className="mt-3">
              {userProfileDetail?.user?.account_quality === "Your account is actived!" ? (
                <div className="mb-3">
                  <p className="text-lg font-bold">Community Standards Violations</p>
                  <div className="flex items-start space-x-3 p-1 mb-3">
                    <img width={20} height={20} src={TickIcon} alt="" />
                    <div>
                      <p className="text-sm font-semibold">{userProfileDetail?.user?.account_quality}</p>
                      <p className="text-secondary-foreground">{userProfileDetail?.user?.account_quality_description}</p>
                    </div>
                  </div>
                  <Separator />
                </div>
              ) : (
                <></>
              )}
            </div>

            <div className="">
              {userProfileDetail?.user?.user_type === "Personal" && (
                <div className="mb-3">
                  <div className="flex justify-between items-center">
                    <p className="text-lg font-bold">Professional</p>
                    <Pencil onClick={() => setIsDialogOpenProfessional(true)} size={18} className="cursor-pointer" />
                  </div>

                  <div className="flex items-center space-x-3 p-1 mb-3">
                    {userProfileDetail?.user?.professional ? (
                      <>
                        <Info />
                        <p className="text-sm font-semibold">{userProfileDetail?.user?.professional}</p>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <Separator />
                </div>
              )}

              {userProfileDetail?.user?.user_type === "Page" && (
                <div className="mb-3">
                  <div className="flex justify-between items-center">
                    <p className="text-lg font-bold">Category</p>
                    <Pencil onClick={() => setIsDialogOpenCategory(true)} size={18} className="cursor-pointer" />
                  </div>
                  <div className="flex items-center space-x-3 p-1 mb-3">
                    {userProfileDetail?.user?.item_group ? (
                      <>
                        <Info />
                        <p className="text-sm font-semibold">{userProfileDetail?.user?.item_group}</p>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <Separator />
                </div>
              )}

              <div className="mb-3">
                <div className="flex justify-between items-center">
                  <p className="text-lg font-bold">Current Address</p>
                  <Pencil onClick={() => setIsDialogOpenCurrentAddress(true)} size={18} className="cursor-pointer" />
                </div>
                <div className="flex items-center space-x-3 p-1 mb-3">
                  {userProfileDetail?.user?.current_address ? (
                    <>
                      <MapPin />
                      <p className="text-sm font-semibold">From {userProfileDetail?.user?.current_address}</p>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <Separator />
              </div>

              {userProfileDetail?.user?.user_type === "Personal" && (
                <div className="mb-3">
                  <div className="flex justify-between items-center">
                    <p className="text-lg font-bold">Birth Address</p>
                    <Pencil onClick={() => setIsDialogOpenBirthAddress(true)} size={18} className="cursor-pointer" />
                  </div>
                  <div className="flex items-center space-x-3 p-1 mb-3">
                    {userProfileDetail?.user?.birth_address ? (
                      <>
                        <House />
                        <p className="text-sm font-semibold">From {userProfileDetail.user.birth_address}</p>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <Separator />
                </div>
              )}

              {userProfileDetail?.user?.user_type === "Personal" && (
                <div className="mb-3">
                  <div className="flex justify-between items-center">
                    <p className="text-lg font-bold">Marital Status</p>
                    <Pencil onClick={() => setIsDialogOpenMaritalStatus(true)} size={18} className="cursor-pointer" />
                  </div>
                  <div className="flex items-center space-x-3 p-1 mb-3">
                    {userProfileDetail?.user?.marital_status ? (
                      <>
                        <Heart />
                        <p className="text-sm font-semibold">{userProfileDetail?.user?.marital_status}</p>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                  <Separator />
                </div>
              )}

              <div className="mb-3">
                <p className="text-lg font-bold">FlipFlop</p>
                <div className="relative flex items-center space-x-3 p-1 mb-3">
                  <div className="cursor-pointer" onClick={setCopied}>
                    <Copy />
                  </div>
                  {isCopied && <span className="absolute top-7 -left-4 text-green-500 text-xs">Copied!</span>}

                  <p onClick={setCopied} className="text-sm font-semibold cursor-pointer">
                    {process.env.REACT_APP_URL}/profile?id=
                    {userProfileDetail?.user?.id}
                  </p>
                </div>
                <Separator />
              </div>

              <div className="mb-3">
                <div className="flex justify-between items-center">
                  <p className="text-lg font-bold">Facebook</p>
                  <Pencil onClick={() => setIsDialogOpenFaceBook(true)} size={18} className="cursor-pointer" />
                </div>
                <div className="flex items-center space-x-3 p-1 mb-3">
                  {userProfileDetail?.user?.facebook_link ? (
                    <>
                      <i className="fa-brands fa-facebook fa-lg" />
                      <Link to={userProfileDetail?.user?.facebook_link} className="text-sm font-semibold">
                        {userProfileDetail?.user?.facebook_link}
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <Separator />
              </div>

              <div className="mb-3">
                <div className="flex justify-between items-center">
                  <p className="text-lg font-bold">Telegram</p>
                  <Pencil onClick={() => setIsDialogOpenTelegram(true)} size={18} className="cursor-pointer" />
                </div>
                <div className="flex items-center space-x-3 p-1 mb-3">
                  {userProfileDetail?.user?.telegram_link ? (
                    <>
                      <i className="fa-brands fa-telegram fa-lg" />
                      <Link to={userProfileDetail?.user?.telegram_link} className="text-sm font-semibold">
                        {userProfileDetail?.user?.telegram_link}
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <Separator />
              </div>

              <div className="mb-3">
                <div className="flex justify-between items-center">
                  <p className="text-lg font-bold">Youtube</p>
                  <Pencil onClick={() => setIsDialogOpenYoutube(true)} size={18} className="cursor-pointer" />
                </div>
                <div className="flex items-center space-x-3 p-1 mb-3">
                  {userProfileDetail?.user?.youtube_link ? (
                    <>
                      <i className="fa-brands fa-youtube fa-lg" />
                      <Link to={userProfileDetail?.user?.youtube_link} className="text-sm font-semibold">
                        {userProfileDetail?.user?.youtube_link}
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <Separator />
              </div>

              <div className="mb-3">
                <div className="flex justify-between items-center">
                  <p className="text-lg font-bold">TikTok</p>
                  <Pencil onClick={() => setIsDialogOpenTiktok(true)} size={18} className="cursor-pointer" />
                </div>
                <div className="flex items-center space-x-3 mt-2 mb-3">
                  {userProfileDetail?.user?.tiktok_link ? (
                    <>
                      <i className="fa-brands fa-tiktok fa-lg" />
                      <Link to={userProfileDetail?.user?.tiktok_link} className="text-sm font-semibold">
                        {userProfileDetail?.user?.tiktok_link}
                      </Link>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <Separator />
              </div>

              {userProfileDetail?.user?.user_type === "Page" ? (
                <>
                  <div className="mb-3">
                    <div className="flex justify-between items-center">
                      <p className="text-lg font-bold">Google Map Link</p>
                      <Pencil onClick={() => setIsDialogOpenGoogleMapLink(true)} size={18} className="cursor-pointer" />
                    </div>
                    <div className="flex items-center space-x-3 mt-2 mb-3">
                      {userProfileDetail?.user?.google_map_link ? (
                        <>
                          <i className="fa-solid fa-map-location-dot fa-lg" />
                          <Link to={userProfileDetail?.user?.google_map_link} className="text-sm font-semibold">
                            {userProfileDetail?.user?.google_map_link}
                          </Link>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <Separator />
                  </div>
                </>
              ) : (
                <></>
              )}

              {userProfileDetail?.user?.user_type === "Personal" && (
                <div className="mb-3">
                  <p className="text-lg font-bold">Workplaces</p>
                  {userProfileDetail?.user_workplaces?.map((item: any) => {
                    return (
                      <div className="flex justify-between items-center w-full space-x-3 p-1 mb-3" key={item.id}>
                        <i
                          onClick={() => {
                            setEditWorkplace(item);
                            setIsDialogOpenWorkplace(true);
                          }}
                          className="fa-solid fa-graduation-cap fa-lg cursor-pointer"
                        />
                        <div
                          className="cursor-pointer w-full"
                          onClick={() => {
                            setEditWorkplace(item);
                            setIsDialogOpenWorkplace(true);
                          }}
                        >
                          <p className="text-sm font-semibold">{item.company_name}</p>
                          <p className="text-sm font-semibold">{item.job_title}</p>
                        </div>
                        {loadingItemWorkplaceId === item.id ? (
                          <Loader className="animate-spin text-yellow-500" />
                        ) : (
                          <AlertDialog>
                            <AlertDialogTrigger asChild>
                              <X className="cursor-pointer" />
                            </AlertDialogTrigger>
                            <AlertDialogContent>
                              <AlertDialogHeader>
                                <AlertDialogTitle>Do you want to delete {item.company_name}?</AlertDialogTitle>
                                <AlertDialogDescription>
                                  Deleting this workplace will remove all associated data. This action cannot be undone. Please continue if you wish to proceed.
                                </AlertDialogDescription>
                              </AlertDialogHeader>
                              <AlertDialogFooter>
                                <AlertDialogCancel>Cancel</AlertDialogCancel>
                                <AlertDialogAction onClick={() => submitRemoveUserWorkplace(item)} className="text-white bg-blue-600 hover:bg-blue-500">
                                  Continue
                                </AlertDialogAction>
                              </AlertDialogFooter>
                            </AlertDialogContent>
                          </AlertDialog>
                        )}
                      </div>
                    );
                  })}
                  <Button
                    onClick={() => {
                      setEditWorkplace(null);
                      setIsDialogOpenWorkplace(true);
                    }}
                    className="mb-3 w-full"
                  >
                    Add Workplaces
                  </Button>
                  <Separator />
                </div>
              )}

              {userProfileDetail?.user?.user_type === "Personal" && (
                <div className="mb-3">
                  <p className="text-lg font-bold">Educations</p>
                  {userProfileDetail?.user_educations?.map((item: any) => {
                    return (
                      <div className="flex justify-between items-center w-full space-x-3 p-1 mb-3" key={item.id}>
                        <i
                          onClick={() => {
                            setEditEducation(item);
                            setIsDialogOpenEducation(true);
                          }}
                          className="fa-solid fa-graduation-cap fa-lg cursor-pointer"
                        />
                        <div
                          className="cursor-pointer w-full"
                          onClick={() => {
                            setEditEducation(item);
                            setIsDialogOpenEducation(true);
                          }}
                        >
                          <p className="text-sm font-semibold">{item.school_name}</p>
                          <p className="text-sm font-semibold">{item.concentration}</p>
                        </div>
                        {loadingItemEducationId === item.id ? (
                          <Loader className="animate-spin text-yellow-500" />
                        ) : (
                          <AlertDialog>
                            <AlertDialogTrigger asChild>
                              <X className="cursor-pointer" />
                            </AlertDialogTrigger>
                            <AlertDialogContent>
                              <AlertDialogHeader>
                                <AlertDialogTitle>Do you want to delete {item.school_name}?</AlertDialogTitle>
                                <AlertDialogDescription>
                                  Deleting this education will remove all associated data. This action cannot be undone. Please continue if you wish to proceed.
                                </AlertDialogDescription>
                              </AlertDialogHeader>
                              <AlertDialogFooter>
                                <AlertDialogCancel>Cancel</AlertDialogCancel>
                                <AlertDialogAction onClick={() => submitRemoveUserEducation(item)} className="text-white bg-blue-600 hover:bg-blue-500">
                                  Continue
                                </AlertDialogAction>
                              </AlertDialogFooter>
                            </AlertDialogContent>
                          </AlertDialog>
                        )}
                      </div>
                    );
                  })}
                  <Button
                    onClick={() => {
                      setEditEducation(null);
                      setIsDialogOpenEducation(true);
                    }}
                    className="mb-3 w-full"
                  >
                    Add Educations
                  </Button>
                  <Separator />
                </div>
              )}

              {userProfileDetail?.user?.user_type === "Page" ? (
                <>
                  <div className="mb-3">
                    <p className="text-lg font-bold">Google Map</p>
                    <div className="h-[400px] w-full mt-2">
                      <GoogleMapPreview latitude={userProfileDetail?.user?.current_latitude} longitude={userProfileDetail?.user?.current_longitude} />
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}

              <div className="mb-3">
                <p className="text-lg font-bold">Joined FlipFlop</p>
                <div className="flex items-center space-x-3 p-1 mb-3">
                  <Info />
                  <p className="text-sm font-semibold">Joined FlipFlop on {moment(userProfileDetail?.user?.created_at).format("MMMM DD, YYYY")}</p>
                </div>
              </div>
            </div>
          </div>

          <DailogGoogleMapLink
            userProfileDetail={userProfileDetail}
            setUserProfileDetail={setUserProfileDetail}
            isDialogOpen={isDialogOpenGoogleMapLink}
            setIsDialogOpen={setIsDialogOpenGoogleMapLink}
          />

          <DialogClickCoverProfile
            itemCoverProfile={itemCoverProfile}
            userAllCoverProfiles={userAllCoverProfiles}
            onValueDelete={(value) => {
              submitDeleteProfileCover(value);
            }}
            setIsDialogOpen={setIsDialogOpenCoverProfile}
            isDialogOpen={isDialogOpenCoverProfile}
          />

          <DialogClickProfilePicture
            itemUserProfile={userProfileDetail.user}
            onValueChange={(value) => {
              if (value?.picture) {
                const updatedUser = {
                  ...userProfileDetail?.user,
                  picture: value.picture,
                  thumbnail: value.thumbnail,
                };

                localStorage.setItem("user", JSON.stringify(updatedUser));
                setUserProfileDetail((prevState: any) => ({
                  ...prevState,
                  user: updatedUser,
                }));
              }
            }}
            setIsDialogOpen={setIsDialogOpenProfilePicture}
            isDialogOpen={isDialogOpenProfilePicture}
          />

          <DailogWorkplace
            setUserProfileDetail={setUserProfileDetail}
            editWorkplace={editWorkplace}
            setEditWorkplace={setEditWorkplace}
            setIsDialogOpen={setIsDialogOpenWorkplace}
            isDialogOpen={isDialogOpenWorkplace}
          />

          <DailogEducations
            setUserProfileDetail={setUserProfileDetail}
            editEducation={editEducation}
            setEditEducation={setEditEducation}
            setIsDialogOpen={setIsDialogOpenEducation}
            isDialogOpen={isDialogOpenEducation}
          />

          <DailogCategories
            userUpdateProfileInformation={userUpdateProfileInformation}
            setUserUpdateProfileInformation={setUserUpdateProfileInformation}
            userProfileDetail={userProfileDetail}
            setUserProfileDetail={setUserProfileDetail}
            isDialogOpen={isDialogOpenCategory}
            setIsDialogOpen={setIsDialogOpenCategory}
          />

          <DailogProfessional
            setUserProfileDetail={setUserProfileDetail}
            userProfileDetail={userProfileDetail}
            isDialogOpen={isDialogOpenProfessional}
            setIsDialogOpen={setIsDialogOpenProfessional}
          />

          <DailogCurrentAddress
            userProfileDetail={userProfileDetail}
            setUserProfileDetail={setUserProfileDetail}
            isDialogOpen={isDialogOpenCurrentAddress}
            setIsDialogOpen={setIsDialogOpenCurrentAddress}
          />

          <DailogBirthAddress
            userProfileDetail={userProfileDetail}
            setUserProfileDetail={setUserProfileDetail}
            isDialogOpen={isDialogOpenBirthAddress}
            setIsDialogOpen={setIsDialogOpenBirthAddress}
          />

          <DailogMaritalStatus
            userProfileDetail={userProfileDetail}
            setUserProfileDetail={setUserProfileDetail}
            isDialogOpen={isDialogOpenMaritalStatus}
            setIsDialogOpen={setIsDialogOpenMaritalStatus}
          />

          <DailogFacebook
            userProfileDetail={userProfileDetail}
            setUserProfileDetail={setUserProfileDetail}
            isDialogOpen={isDialogOpenFaceBook}
            setIsDialogOpen={setIsDialogOpenFaceBook}
          />

          <DailogTelegram
            userProfileDetail={userProfileDetail}
            setUserProfileDetail={setUserProfileDetail}
            isDialogOpen={isDialogOpenTelegram}
            setIsDialogOpen={setIsDialogOpenTelegram}
          />

          <DailogYoutube
            userProfileDetail={userProfileDetail}
            setUserProfileDetail={setUserProfileDetail}
            isDialogOpen={isDialogOpenYoutube}
            setIsDialogOpen={setIsDialogOpenYoutube}
          />

          <DailogTiktok
            userProfileDetail={userProfileDetail}
            setUserProfileDetail={setUserProfileDetail}
            isDialogOpen={isDialogOpenTiktok}
            setIsDialogOpen={setIsDialogOpenTiktok}
          />
        </>
      ) : (
        <></>
      )}
    </SettingContentLayout>
  );
}
